import Controller from '@ember/controller';
import { htmlSafe } from '@ember/template';

import { ContentWrapper } from 'register-partners-js/react/components/content-wrapper';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';

import styles from './styles.module.css';

export default class WelcomeNotOwnerController extends Controller {
  mainLayout = MainLayout;

  styles = styles;
  contentWrapper = ContentWrapper;

  get emailHTML() {
    return htmlSafe(
      `<span class="${styles['email']}" data-test-not-owner-email>${this.model.redirection.ownerEmail}</span>`
    );
  }
}
